export function textWithEllipse(text: string, length: number = 100): string {
  if (!text) return '';
  return text?.length > length ? `${text.substring(0, length)}...` : text;
}

export function asPx(value: number) {
  return `${value || 0}px`;
}
